module.exports = __webpack_public_path__ + "img/mail-support.a08e605.svg";